import { differenceInMilliseconds, isValid } from 'date-fns'
import { TAuthSlice } from 'modules/login/types'
import { authActions } from 'src/store/auth'
import { store } from 'store/store'

import { getCookie } from '../cookie/cookie'

export interface IToken {
  exp: number
  iat: number
  roles: string[]
  username: string
}

export class TimeService {
  private static instance: TimeService

  private serverTimeOffsetInMillisec = 0

  public static getInstance() {
    if (!TimeService.instance) {
      TimeService.instance = new TimeService()
    }

    return TimeService.instance
  }

  public now() {
    return Date.now() + this.serverTimeOffsetInMillisec
  }
}

export const getDelay = (date: number | string, delta: number): number | undefined => {
  if (isValid(new Date(date))) {
    return differenceInMilliseconds(new Date(date), new Date()) - delta * 60 * 1000
  }
}

export const getDecodedTokenPayload = (token?: string): IToken | undefined => {
  if (!token) {
    return
  }

  const payload = token.split('.')[1]

  return payload ? JSON.parse(window.atob(payload)) : undefined
}

export const setAuthInfo = ({ token, refreshToken }: Pick<TAuthSlice, 'token' | 'refreshToken'>) => {
  const decodedToken = getDecodedTokenPayload(token)

  if (decodedToken) {
    const validUntil = (decodedToken.exp - decodedToken.iat) * 1000 + new Date().getTime()
    store.dispatch(authActions.setAuthInfo({ refreshToken, token, validUntil }))

    return Promise.resolve()
  }

  return Promise.reject()
}

export const getAccessToken = () => getCookie({ name: 'token' })
export const getRefreshToken = () => getCookie({ name: 'refreshToken' })

export const getAccessValidUntil = () => getCookie({ name: 'validUntil' })
